module.exports = __webpack_public_path__ + "static/media/farmerspostveg.3555cf2a.png";